export default `
    fragment ParagraphQuickAccess on ParagraphQuickAccess{
      id
      uuid
      entityBundle
    }
`
